import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { Snackbar, CircularProgress, Alert, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from './LocalizationProvider';
import { useCatch } from '../../reactHelper';
import { snackBarDurationLongMs } from '../util/duration';

const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      bottom: `calc(${theme.dimensions.bottomBarHeight}px + ${theme.spacing(1)})`,
    },
  },
  button: {
    height: 'auto',
    marginTop: 0,
    marginBottom: 0,
  },
  actionContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

const MultiActionDialog = ({
  open,
  actionType, // 'delete' | 'block' | 'unblock'
  itemId,
  onResult,
}) => {
  const { classes } = useStyles();
  const t = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) {
      setLoading(false);
      setError(null);
    }
  }, [open]);

  const handleAction = useCatch(async () => {
    console.log('Iniciando ação de', actionType);
    setLoading(true);
    setError(null);

    try {
      console.log('Enviando requisição para API');
      let response;

      if (actionType === 'delete') {
        response = await fetch(`/api/devices/${itemId}`, {
          method: 'DELETE'
        });
        console.log('Resposta da API:', response.status);
      } else {
        response = await fetch('/api/commands/send', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            deviceId: itemId,
            type: actionType === 'block' ? 'engineStop' : 'engineResume'
          }),
        });
      }

      if (!response.ok) throw Error(await response.text());
      onResult(true);
    } catch (err) {
      console.error('Erro completo:', err);
      setError(err.message);
      onResult(false);
    } finally {
      setLoading(false);
    }
  }); // <-- Este ponto e vírgula estava faltando

  const getDialogConfig = () => {
    switch (actionType) {
      case 'delete':
        return {
          message: t('sharedRemoveConfirm'),
          buttonText: t('sharedRemove'),
          color: 'error'
        };
      case 'block':
        return {
          message: t('confirmBlockCommand'),
          buttonText: t('sharedLock'),
          color: 'warning'
        };
      case 'unblock':
        return {
          message: t('confirmUnblockCommand'),
          buttonText: t('sharedUnlock'),
          color: 'success'
        };
      default:
        return {};
    }
  };

  const { message, buttonText, color } = getDialogConfig();

  if (!open) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={null} // Remove auto-fechamento
      onClose={(event, reason) => {
        if (reason === 'clickaway') {
          return; // Ignora cliques fora
        }
        onResult(false); // Só fecha se explicitamente cancelado
      }}
      message={message}
      action={
        <Box>
          {error && <Alert severity="error">{error}</Alert>}
          <Box className={classes.actionContainer}>
            <Button onClick={() => onResult(false)}>Cancelar</Button>
            <Button onClick={handleAction} color={color}>
              Confirmar
            </Button>
          </Box>
        </Box>
      }
    />
  );
};

export default MultiActionDialog;